import "core-js/modules/es.string.pad-start";
import moment from 'moment';
export class DateHelper {
  static getCurrentDate() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!

    var yyyy = today.getFullYear();
    var todayStr = yyyy + '-' + mm + '-' + dd;
    return todayStr;
  }

  static formatStringDate(date) {
    return date ? moment(date, 'YYYY-MM-DD') : null;
  }

}